import React from "react";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Portal } from "@radix-ui/react-dropdown-menu";

interface ItemDropdownMenuProps {
  onRename: () => void;
  onDelete: () => void;
  onDuplicate?: () => void;
  onPin?: () => void;
  isPinned?: boolean;
  config: {
    isDuplicateEnabled: boolean;
    isDeleteEnabled: boolean;
    isRenameEnabled: boolean;
    isPinEnabled?: boolean;
  };
}

export const ItemDropdownMenu: React.FC<ItemDropdownMenuProps> = ({
  onRename,
  onDelete,
  onDuplicate,
  onPin,
  isPinned,
  config = {
    isDuplicateEnabled: true,
    isDeleteEnabled: true,
    isRenameEnabled: true,
    isPinEnabled: false,
  },
}) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          aria-label="Actions"
          className="z-50 h-8 w-8 p-0 opacity-0 group-hover:opacity-100 flex-shrink-0"
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <Portal forceMount>
        <DropdownMenuContent align="end" sideOffset={5} className="z-[100]">
          {config.isPinEnabled && (
            <DropdownMenuItem onClick={onPin}>
              {isPinned ? "Unpin" : "Pin"}
            </DropdownMenuItem>
          )}
          {config.isRenameEnabled && (
            <DropdownMenuItem onClick={onRename}>Rename</DropdownMenuItem>
          )}
          {config.isDuplicateEnabled && (
            <DropdownMenuItem onClick={onDuplicate}>Duplicate</DropdownMenuItem>
          )}
          {config.isDeleteEnabled && (
            <DropdownMenuItem onClick={onDelete} className="text-primary">
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </Portal>
    </DropdownMenu>
  );
};
